import { memo } from 'react';
import { useAnimatedStyle, interpolate } from 'react-native-reanimated';
import { ParallaxListItemProps } from './ParallaxListItem.types';
import Box from '../../Box/Box';

function ParallaxListItem({
  index,
  itemWidth,
  scrollX,
  children,
  ...rest
}: ParallaxListItemProps) {
  const animatedStyle = useAnimatedStyle(() => {
    const inputRange = [
      (index - 1) * itemWidth,
      index * itemWidth,
      (index + 1) * itemWidth,
    ];

    return {
      transform: [
        {
          scale: interpolate(
            scrollX.value,
            inputRange,
            [0.5, 1.5, 0.5],
            'clamp',
          ),
        },
        {
          translateX: interpolate(
            scrollX.value,
            inputRange,
            [itemWidth / 2, 0, -itemWidth / 2],
            'clamp',
          ),
        },
      ],
      opacity: interpolate(scrollX.value, inputRange, [0.5, 1, 0.5], 'clamp'),
    };
  });

  return (
    <Box width={itemWidth} {...rest}>
      <Box height="100%" animatedStyle={animatedStyle} centerContent>
        {children}
      </Box>
    </Box>
  );
}

export default memo(ParallaxListItem);
